import { connect } from 'react-redux';

// View
import AttributeSelector from './AttributeSelector';

const mapStateToProps = (state: any) => {
  return {
    isCreateAttributeDialogOpen: state.attribute.isCreateAttributeDialogOpen,
  };
};

export default connect(
  mapStateToProps,
  {},
)(AttributeSelector);
